module.exports = __webpack_public_path__ + "img/infograph_6.8844e171.png";